import { render, staticRenderFns } from "./TopCard.vue?vue&type=template&id=09be7657&scoped=true&"
import script from "./TopCard.vue?vue&type=script&lang=js&"
export * from "./TopCard.vue?vue&type=script&lang=js&"
import style0 from "./TopCard.vue?vue&type=style&index=0&id=09be7657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be7657",
  null
  
)

export default component.exports